const FEATURES = [
  {
    icon: 'ri-database-2-line',
    title: '海量片库',
    desc: '收录超过10000部日本电影与韩国电影资源，涵盖动作、爱情、悬疑、动画、历史等多种题材，经典与最新同步覆盖。',
  },
  {
    icon: 'ri-4k-line',
    title: '高清画质',
    desc: '全网日韩电影高清片源，支持多清晰度选择，在家也能享受影院级视觉体验，韩国电影免费高清观看。',
  },
  {
    icon: 'ri-speed-line',
    title: '急速播放',
    desc: '多线CDN加速，韩国电影免费在线观看无需缓冲等待，全网最优播放体验，流畅不卡顿。',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日更新',
    desc: '片库每天同步最新日韩电影资源，新片速递第一时间上线，日本电影免费与韩国电影免费一站畅享。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全免费',
    desc: '无需注册，无需付费，无需下载，打开即看。所有日韩电影在线资源安全纯净，无弹窗广告干扰。',
  },
];

export default function Features() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">平台优势</h2>
        <p className="text-sm text-foreground-500 mb-8">为什么千万影迷选择日韩影视网</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {FEATURES.map((f, i) => (
            <div key={i} className="bg-background-50 rounded-xl p-5 border border-background-200/70 group hover:border-primary-200 transition-colors">
              <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-accent-100 mb-4 group-hover:bg-accent-200 transition-colors">
                <i className={`${f.icon} text-accent-600 text-xl`}></i>
              </div>
              <h3 className="font-heading text-base text-foreground-900 mb-2">{f.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}